import AppLayout from '../layout/AppLayout';

const PageNotFound = () => {
  return (
    <AppLayout>
      <div className='not-found-page'>
        <img
          className='not-found-image'
          src='https://res.cloudinary.com/tejeshreddy17/image/upload/v1643982018/erroring_1_lyci8b.jpg'
          alt='page not found'
        />
        <h1 className='not-found-heading'>Page Not Found</h1>
        <p className='not-found-description'>
          We are sorry, the page you requested could not be found.
        </p>
      </div>
    </AppLayout>
  );
};

export default PageNotFound;
